// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__HAfHO","inputWrap":"Table_inputWrap__-oOjg","col":"Table_col__1bcdh","bmiTooltip":"Table_bmiTooltip__1FZyY"};